// extracted by mini-css-extract-plugin
export default {"breadCrumb":"style_breadCrumb__9wYC7","separator":"style_separator__mFUDe"};